import { useEffect, useState } from "react";
import { Autocomplete, Button, Stack, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import "../i18n";
import { getProductSuggestions } from "../api/products";
import { getOfflineCatalogFilterValues } from "../offline/catalog";

export default function CatalogFilters({ brand, category, onBrandChange, onCategoryChange, isOnline, workspacePublicId, storePublicId }) {
  const { t } = useTranslation();
  const [brandInput, setBrandInput] = useState("");
  const [categoryInput, setCategoryInput] = useState("");
  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => { setBrands([]); setCategories([]); setBrandInput(""); setCategoryInput(""); }, [workspacePublicId]);

  useEffect(() => {
    let active = true;
    const timer = setTimeout(() => {
      const suggestions = (field, query) => isOnline
        ? getProductSuggestions(field, query, 50).then((response) => response.data || [])
        : getOfflineCatalogFilterValues({ workspacePublicId, storePublicId, field, query });
      Promise.all([suggestions("brand", brandInput), suggestions("category", categoryInput)])
        .then(([nextBrands, nextCategories]) => {
          if (active) { setBrands(nextBrands); setCategories(nextCategories); }
        })
        .catch(() => { if (active) { setBrands([]); setCategories([]); } });
    }, 200);
    return () => { active = false; clearTimeout(timer); };
  }, [brandInput, categoryInput, isOnline, workspacePublicId, storePublicId]);

  return (
    <Stack direction={{ xs: "column", sm: "row" }} gap={1.5} sx={{ mt: 1.5, alignItems: { sm: "center" } }}>
      <Autocomplete freeSolo autoSelect options={brands} filterOptions={(values) => values} value={brand || null}
        inputValue={brandInput} onInputChange={(_, value) => setBrandInput(value)}
        onChange={(_, value) => onBrandChange(value || "")} sx={{ minWidth: 180, flex: 1 }}
        renderInput={(params) => <TextField {...params} label={t("catalog.brand")} placeholder={t("catalog.allBrands")} size="small" />} />
      <Autocomplete freeSolo autoSelect options={categories} filterOptions={(values) => values} value={category || null}
        inputValue={categoryInput} onInputChange={(_, value) => setCategoryInput(value)}
        onChange={(_, value) => onCategoryChange(value || "")} sx={{ minWidth: 180, flex: 1 }}
        renderInput={(params) => <TextField {...params} label={t("catalog.category")} placeholder={t("catalog.allCategories")} size="small" />} />
      {(brand || category) && <Button onClick={() => { onBrandChange(""); onCategoryChange(""); }}>{t("catalog.clearFilters")}</Button>}
    </Stack>
  );
}
